module.exports = __webpack_public_path__ + "f448937d3d7c899e011d9b823e007af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oops.png
// module id = 2437
// module chunks = 85